import { getVideoIdsFromArticle } from './videoUtils';

export async function fetchVideosMetadataClient(document) {
  const videoIds = getVideoIdsFromArticle(document);

  if (!videoIds.length) {
    return {};
  }

  const entries = await Promise.all(
    videoIds.map(async (videoId) => {
      try {
        const response = await fetch(`/api/youtube-metadata?videoId=${encodeURIComponent(videoId)}`);

        if (!response.ok) {
          return null;
        }

        const metadata = await response.json();

        return metadata ? [videoId, metadata] : null;
      } catch {
        return null;
      }
    }),
  );

  return Object.fromEntries(entries.filter(Boolean));
}
